import { IGcpAppDispatch } from "../../../redux/store";
import { getSiteState, IStoreState } from "../../../redux/rootReducer";
import { fitGeojsonBounds } from "../../../map/reusableLayers/NavigationLayer/NavigationLayer";
import { IGcpAppIo } from "../../../redux/io";
import { FIT_SITE_SELECTED } from "../../../tracking/constants";

export const userClicksFitSiteButton =
  () =>
  async (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    trackAction(FIT_SITE_SELECTED);
    const siteState = getSiteState(getState());
    dispatch(fitGeojsonBounds(siteState.data.boundary));
  };
